import moment from "moment";

export const TEMPLATE_REPORT_FILTERS = {
  reportId: "D0",
  showReport: false,
  selectedReport: { title: "Daily Inspections Summary", name: "DIS", reportId: "D0" },
  dateRange: { from: new Date(moment().startOf("day")), today: new Date(moment().startOf("day")), to: new Date(moment().endOf("day")) },
  selectedAssetOption: { val: "select", text: "Select" },
};

export const getCurrentDailyReportStateFilters = (reportFilterState) => {
  let stateToReturn = TEMPLATE_REPORT_FILTERS;
  if (reportFilterState) {
    stateToReturn = {
      reportId: reportFilterState.reportId,
      dateRange: reportFilterState.dateRange,
      selectedReport: reportFilterState.selectedReport,
      showReport: reportFilterState.showReport,
      selectedAssetOption: reportFilterState.selectedAssetOption,
    };
  }
  return stateToReturn;
};



// WEBPACK FOOTER //
// ./src/components/ReVAMPDailyInpectionReports/StateRetentionMethods/stateRetentionManagement.js